import { render } from "./Proxy.vue?vue&type=template&id=5fbd42ba&scoped=true"
import script from "./Proxy.vue?vue&type=script&lang=js"
export * from "./Proxy.vue?vue&type=script&lang=js"

import "./Proxy.vue?vue&type=style&index=0&id=5fbd42ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fbd42ba"]])

export default __exports__